import { Controller } from "@hotwired/stimulus"
import { debounce, patchJson, sessionIdFor } from "./sweeper_shared"

export default class extends Controller {
  update(event) {
    const field = event.target.closest("[data-vfield]")
    if (!field) return

    field.parentElement?.classList.toggle("checked", field.checked)
    debounce(this, `virtue:${field.dataset.vfield}:${field.dataset.key}`, () => {
      this.saveField(field)
    })
  }

  score(event) {
    const scoreButton = event.target.closest("[data-score]")
    const clearButton = event.target.closest("[data-score-clear]")
    if (!scoreButton && !clearButton) return

    const fieldId = scoreButton?.dataset.score || clearButton.dataset.scoreClear
    const score = scoreButton ? parseInt(scoreButton.dataset.val, 10) : 0
    this.renderScore(fieldId, score)
    this.save(fieldId, { score })
  }

  saveField(field) {
    const fieldId = field.dataset.vfield
    const key = field.dataset.key
    let value

    if (field.type === "checkbox" && field.dataset.val) {
      value = Array.from(this.element.querySelectorAll(`[data-vfield="${fieldId}"][data-key="${key}"]:checked`))
        .map(input => input.dataset.val)
    } else if (field.type === "checkbox") {
      value = field.checked
    } else {
      value = field.value
    }

    this.save(fieldId, { [key]: value })
  }

  save(fieldId, attrs) {
    const sessionId = sessionIdFor(this.element)
    if (!sessionId) return

    patchJson(`/api/v1/sessions/${encodeURIComponent(sessionId)}/virtue`, {
      field_id: fieldId,
      attrs
    })
  }

  renderScore(fieldId, score) {
    const row = this.element.querySelector(`[data-score-row="${fieldId}"]`)
    if (!row) return

    const scoreClass = score >= 8 ? "good" : score >= 6 ? "warn" : score > 0 ? "bad" : ""
    row.querySelectorAll("[data-score]").forEach(button => {
      const value = parseInt(button.dataset.val, 10)
      button.className = "score-dot"
      if (value <= score) button.classList.add("filled", scoreClass)
    })

    let clear = row.querySelector("[data-score-clear]")
    if (score > 0 && !clear) {
      clear = document.createElement("button")
      clear.className = "score-clear"
      clear.dataset.scoreClear = fieldId
      clear.type = "button"
      clear.textContent = "wissen"
      clear.setAttribute("data-action", "click->sweeper-editor-virtues#score:stop")
      row.appendChild(clear)
    } else if (score === 0 && clear) {
      clear.remove()
    }
  }
}
